export const appendLeftArrow = (str: string): string => `‹ ${str}`;
